import { MDSText, MDSTextVariant, MDSTextWeight, MDSTextColor } from "@/mds";
import styled from "@emotion/styled";
import { ListBoxItem } from "react-aria-components";

interface CollectionsFacetFilterNoResultsProps {
  searchText: string;
}

export const CollectionsFacetFilterNoResults = ({
  searchText,
}: CollectionsFacetFilterNoResultsProps) => {
  return (
    <Wrapper>
      <MDSText
        variant={MDSTextVariant.TextS}
        weight={MDSTextWeight.Regular}
        color={MDSTextColor.Secondary}
      >
        {searchText
          ? "No results match your current search"
          : "You haven't created any collections yet"}
      </MDSText>
    </Wrapper>
  );
};

const Wrapper = styled(ListBoxItem)`
  padding-inline: ${({ theme }) => theme.spacing["5"]};
  padding-block: ${({ theme }) => theme.spacing["2"]};
`;
